export default __webpack_public_path__ + "static/media/button-app-store.5ebf01b5.svg";